// 监听屏幕尺寸变化
import { useWindowSize, watchDebounced } from '@vueuse/core'
import useAppStore from '@/store/modules/app.js';

export function useScreenDetect() {
  const appStore = useAppStore()
  const { width } = useWindowSize()

  // 响应式监听逻辑
  const stopWatch = watchDebounced(
    width,
    (newWidth) => {
      appStore.isMobile = newWidth < appStore.breakpoint
    },
    {
      debounce: 300,
      maxWait: 1000,
      immediate: true // 初始化立即执行
    }
  )

  return { stopWatch }
}